module.exports = __webpack_public_path__ + "static/media/phonebook.6f6977d6.svg";